import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, Chip, Grid, MenuItem, Select, Stack, TextField, Typography, Box, CircularProgress, IconButton, Menu, ListItemIcon, ListItemText, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import NetraScoreBadge from "../NetraScoreBadge";
import RtoRiskBadge from "../RtoRiskBadge";
import { netraStageNote } from "../netraStageNote";
import React, { useEffect, useRef, useState } from 'react';
import ProzoDataGrid from '../../../common/ProzoDataGrid';
import { ChannelIcon, formatCurrency, formatDate, formatNumber, maskEmail, maskPhoneNumber, shouldMaskData } from '../../../helpers/UtilityHelper';
import { useGetChannelOrderQuery, useGenericPostRequestQuery } from '../../../redux/commonRTK';
import _ from 'lodash'
import Loader from '../../../common/Loader';
import MUIModal from '../../../common/MUIModal';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { UploadFileOutlined } from '@mui/icons-material';
import { getMerchant } from '../../../helpers/ReduxHelpers';
import { getGeneric, apiConstants, postGeneric, post, postMultipart, CHANNEL_ORDER_BATCH_SIZE } from '../../../common/constants';
import { useForm } from 'react-hook-form';
import RtoAddressSelector, { RTO_DEFAULT_VALUES, buildReturnDetails, rtoLocationRule } from '../RtoAddressSelector';
import { FormProvider, RHFDateRangePickerField, RHFFileField, RHFRadioGroup, RHFSelectField, RHFSearchableSelectField, RHFTextField } from '../../../common/hook-form';
import { WEIGHT_FILTER_DEFAULTS, WeightRangeFields, buildWeightFilters } from './weightFilter'
import { LoadingButton } from '@mui/lab';
import DownloadSampleFile from '../../../common/DownloadSampleFile';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup'
import { useGetCouriersQuery } from '../../../redux/commonRTKPersist';
import { useSnackbar } from 'notistack';
import { useGridApiContext } from '@mui/x-data-grid';
import EditCustomerDetails from './EditCustomerDetails';
import CustomerOrderHistoryModal from './CustomerOrderHistoryModal';
import { addDays, format } from 'date-fns';
import { ExpandMoreOutlined } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SyncOutlinedIcon from '@mui/icons-material/Sync';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Link } from 'react-router-dom';
import CopyIcon from '../../../common/CopyIcon';
import { useSelector } from 'react-redux';
import jwt_decode from "jwt-decode"
import { getToken } from '../../../helpers/ReduxHelpers';
import { filterBarSx, primaryBtnSx, secondaryBtnSx, btnRowSx } from '../../../styles/patterns';
import ChannelOrderExportButton from './ChannelOrderExportButton';
import BulkAddressUpload from './BulkAddressUpload';
import { primaryTextSx, secondaryTextSx, cellStackSx, getPaymentChipSx, getStatusChipSx } from './cellStyles';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY, SUBTLE, PRIMARY_BLUE, BORDER, WARNING, WARNING_BG, withOpacity } from '../../../styles/foundation/colors';
import { RADIUS } from '../../../styles/foundation/spacing';

// Channel-order items carry their images under `image_urls` (array of URLs; may also
// arrive as a comma-separated string). Normalise to an array either way.
const getItemImages = (item) => {
  const raw = item?.image_urls;
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (typeof raw === 'string') return raw.split(',').map((s) => s.trim()).filter(Boolean);
  return [];
};

const PlacedOrderForContext = React.createContext()
const MerchantContext = React.createContext()
const diableSelection = ['CANCELLED']

// Maps a DataGrid column's UI field to the backend document field to sort by --
// the grid's own `field` values ('channel', 'channelOrderId') are just column
// identities here, not real sortable document paths (see their renderCell usage).
// Default landing sort: newest-created first (the "Order Date" column). createdDate is a
// real timestamp, so this is reliably "latest on top" for every merchant -- unlike
// order_number, which is a String and sorts lexicographically ("9999" above "10000").
const DEFAULT_SORT_MODEL = [{field: 'channelOrderId', sort: 'desc'}]

// Builds the OR-filter that identifies "this customer's other orders" for
// the View History button/modal. Prefers the channel's own numeric
// customer id (e.g. Shopify's customer.id) over phone/email, because the
// backend replaces customer.phone/customer.email with the literal string
// "*****" server-side for any logged-in user who lacks PII access
// (ChannelController.maskPiiInfo) — relying on phone/email alone made
// View History permanently unusable for those users even when the
// customer's order history genuinely exists. customer.id is never masked.
// Max repeat-customer checks in flight at once. One request per row (20 by
// default) saturates the browser's ~6-connections-per-host budget, which stalls
// every other request on the page — including the user's own search.
const HISTORY_CHECK_CONCURRENCY = 3;

const getCustomerIdentityFilter = (row) => {
  const customerId = row.customer?.id;
  const phone = row.customer?.phone;
  const email = row.customer?.email;
  const orfilter = [];
  if (customerId) orfilter.push({ field: 'customer.id', operator: 'eq', value: customerId });
  if (phone && phone !== '*****') orfilter.push({ field: 'customer.phone', operator: 'eq', value: phone });
  if (email && email !== '*****') orfilter.push({ field: 'customer.email', operator: 'eq', value: email });
  return { orfilter, cacheKey: `${customerId || ''}|${phone || ''}|${email || ''}`, hasIdentity: orfilter.length > 0 };
};

export default function UnfulfilledChannelOrders({ canceled = false, onArchived }) {
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [sortModel, setSortModel] = useState(DEFAULT_SORT_MODEL);
  const [orderItems, setOrderItems] = useState(null)
  const [previewImage, setPreviewImage] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [rowSelectionModel, setRowSelectionModel] = useState([])
  const [combinedData, setCombinedData] = useState([])
  const [placeOrderFor, setPlaceOrderFor] = useState([])
  const [merchant, setMerchant] = useState(null)
  // const [skuDetails, setSkuDetails] = useState([])
  // const [finalData, setFinalData] = useState([])
  const [fulfilledItem, setFulfilledItem] = useState(null)
  const [andFilters, setAndFilters] = useState([]);
  const [orFilters, setOrFilters] = useState([]);
  const [appliedSkuFilter, setAppliedSkuFilter] = useState('')
  const merchantD = getMerchant();
  const merchantId = merchantD.id ? merchantD.id : ''
  const { report } = useSelector(state => state);
  const { piiAccessAllow } = jwt_decode(getToken());
  const [isResyncing, setIsResyncing] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false)
  const [cancelDialogRow, setCancelDialogRow] = useState(null)
  // Whether a customer (keyed by phone|email) has more than just this one
  // order — drives the "View History" button's enabled/blue state. Cached so
  // repeat customers on the page (or across re-renders) aren't re-queried.
  const [customerHistoryCache, setCustomerHistoryCache] = useState({})
  const historyCheckInFlight = useRef(new Set())
  // Channel-order cancellation is enabled only for specific merchant accounts.
  const CANCEL_ALLOWED_MERCHANT_OIDS = ['6a3d0cb65dbb267b5e18c28d', '62bd6571dba4e03d87d2ba4c'] // OxyGlow Herbals, Prozo tech team account
  const canCancel = CANCEL_ALLOWED_MERCHANT_OIDS.includes(merchantD?.id)


  const defaultFilters = [
    { field: "merchant.$id", operator: "eq", value: merchantId },
  ]
  // New tab shows actionable statuses (no cancelled); the Cancelled tab shows only cancelled.
  if (canceled) {
    defaultFilters.push({ field: 'channelOrderStatus', operator: 'eq', value: 'CANCELLED' })
  } else {
    defaultFilters.push({ field: 'channelOrderStatus', operator: 'in', value: ['CREATED', 'HOLD', 'DELETED', 'RELEASE', 'PARTIALLY_FULLFILLED'] })
  }

  const methods = useForm({
    defaultValues: {
      order_number: '',
      order_name: '',
      awb_Number: '',
      payment_mode: '',
      email: '',
      phone: '',
      orderConfirmationStatus: '',
      addressVerificationStatus: '',
      tagsValue: '',
      sku: '',
      itemName: '',
      ...WEIGHT_FILTER_DEFAULTS,
      fromDate: '',
      toDate: '',
    }
  });

  const {
    handleSubmit,
    reset
  } = methods;

  // The server sort is fixed to newest-created first; it is not driven by the column
  // arrows. Column sorting is handled client-side (sortingMode="client" on the grid),
  // so clicking a header reorders the rows already loaded without another API call.
  const { data, isLoading, isFetching, refetch } = useGetChannelOrderQuery({
    andfilter: [...defaultFilters, ...andFilters],
    orfilter: [...orFilters],
    sort: { field: "createdDate", direction: "DESC" },
    "offset": (page * sizePerPage),
    "limit": sizePerPage,
    "excludes": "sla,merchant,mappedOrderRule"
  })

  // Sorting is client-side (sortingMode="client" on the grid): the column arrows reorder
  // only the rows currently loaded on screen -- no API call, no pagination reset. A 3rd
  // click clears MUI's sortModel; fall back to the default (newest created first).
  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel.length > 0 ? newSortModel : DEFAULT_SORT_MODEL)
  }

  useEffect(() => {
    if (merchantId) {
      getGeneric(`${apiConstants.GET_MERCHANT}/${merchantId}`)
        .then((response) => {
          setMerchant(response?.data)
        }).catch((err) => console.error(err))
    }
  }, [merchantId])

  // Accumulate data from all pages
  useEffect(() => {
    if (data?.data) {
      setCombinedData(prevData => {
        const newData = data.data.filter(newItem =>
          !prevData.some(prevItem => prevItem.id === newItem.id)
        );
        return [...prevData, ...newData];
      });
    }
  }, [data?.data])

  // For every customer on this page we haven't already checked, ask (via a
  // cheap countOnly query — no documents fetched) whether they have more
  // than this one order. Deduped per unique identity so repeat customers
  // across pages only cost one request.
  useEffect(() => {
    const inFlight = historyCheckInFlight.current;
    const queue = [];
    (data?.data || []).forEach((row) => {
      const { orfilter, cacheKey, hasIdentity } = getCustomerIdentityFilter(row);
      if (!hasIdentity) return;
      if (customerHistoryCache[cacheKey] !== undefined || inFlight.has(cacheKey)) return;
      inFlight.add(cacheKey);
      queue.push({ orfilter, cacheKey });
    });
    if (queue.length === 0) return undefined;

    let cancelled = false;

    // Fetch two ids and test the length rather than asking for a count:
    // countOnly runs countDocuments, which cannot stop early and so walks every
    // match (the old `limit: 1` did nothing to bound it). We only need ">1".
    const checkOne = ({ orfilter, cacheKey }) =>
      postGeneric(apiConstants.CHANNEL_ORDER_SEARCh, {
        orfilter, limit: 2, includes: 'id', skipCount: true,
      })
        .then((res) => {
          if (cancelled) return;
          setCustomerHistoryCache((prev) => ({
            ...prev, [cacheKey]: (res.data?.data?.length || 0) > 1,
          }));
        })
        .catch(() => {
          if (cancelled) return;
          setCustomerHistoryCache((prev) => ({ ...prev, [cacheKey]: false }));
        })
        .finally(() => {
          inFlight.delete(cacheKey);
        });

    // Small worker pool — a few in flight, the rest wait their turn.
    const runWorker = async () => {
      while (!cancelled && queue.length) {
        await checkOne(queue.shift());
      }
    };
    for (let i = 0; i < Math.min(HISTORY_CHECK_CONCURRENCY, queue.length); i += 1) runWorker();

    return () => {
      cancelled = true;
      // Un-mark anything still queued so a later render can retry it.
      queue.forEach(({ cacheKey }) => inFlight.delete(cacheKey));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.data])

  // Convert selected IDs to full row objects
  useEffect(() => {
    const resultArray = combinedData.filter(obj =>
      rowSelectionModel.includes(obj.id)
    );
    if (resultArray?.length > 0) {
      setSelectedRows(resultArray)
    } else {
      setSelectedRows([])
    }
  }, [JSON.stringify(rowSelectionModel), combinedData])

  // useEffect(() => {
  //   if (data?.data?.length > 0) {
  //     let skus = data?.data?.map((row) => row.orderItems)
  //     skus = skus.flat().map((row) => row.sku_id)
  //     skus = [...new Set(skus)]
  //     postGeneric(apiConstants.GET_SKU_DIM, { skuList: skus })
  //       .then((_response) => {
  //         setSkuDetails(_response.data)
  //       }).catch((_err) => {
  //         console.log(_err)
  //       })
  //   }
  // }, [data])

  const applyPickupFilters = (filters) => {
    let appliedPickupFilters = [];
    // "Weight Between" (grams): checked first so an invalid range changes nothing.
    const weight = buildWeightFilters(filters)
    if (weight.error) {
      enqueueSnackbar(weight.error, { variant: 'error' })
      return
    }
    appliedPickupFilters.push(...weight.filters)
    if (filters.order_number) {
      appliedPickupFilters.push({ "field": "order_number", "operator": "in", "value": [...filters.order_number.split(',')] })
    }
    if (filters.order_name) {
      appliedPickupFilters.push({ "field": "orderName", "operator": "in", "value": [...filters.order_name.split(',')] })
    }
    if (filters.payment_mode) {
      appliedPickupFilters.push({ "field": "paymentMode", "operator": "eq", "value": filters.payment_mode })
    }
    if (filters.phone) {
      appliedPickupFilters.push({ "field": "customer.phone", "operator": "eq", "value": '+91' + filters.phone })
    }
    if (filters.email) {
      appliedPickupFilters.push({ "field": "customer.email", "operator": "eq", "value": filters.email })
    }
    if (filters.store_name) {
      appliedPickupFilters.push({ "field": "store_name", "operator": "eq", "value": filters.store_name })
    }
    if (filters.orderConfirmationStatus) {
      appliedPickupFilters.push({ "field": "orderConfirmationStatus", "operator": "eq", "value": filters.orderConfirmationStatus })
    }
    if (filters.addressVerificationStatus) {
      appliedPickupFilters.push({ "field": "addressVerificationStatus", "operator": "eq", "value": filters.addressVerificationStatus })
    }
    if (filters.tagsValue) {
      appliedPickupFilters.push({ "field": "tags", "operator": "like", "value": filters.tagsValue })
    }
    if (filters.fromDate) {
      // Filter on createdDate (what the "Order Date" column shows). Not every channel sets orderDate
      // (Bulk Upload / WooCommerce / Magento orders have none), so filtering on it matched nothing.
      appliedPickupFilters.push({ field: 'createdDate', operator: 'gte', value: `Date('${formatDate(filters.fromDate, 'yyyy-MM-dd')} 00:00:00')` })
    }
    if (filters.toDate) {
      appliedPickupFilters.push({ field: 'createdDate', operator: 'lte', value: `Date('${formatDate(filters.toDate, 'yyyy-MM-dd')} 23:59:59')` })
    }
    if (filters.sku) appliedPickupFilters.push({ field: 'orderItems.skuId', operator: 'eq', value: filters.sku })
    if (filters.itemName) appliedPickupFilters.push({ field: 'orderItems.title', operator: 'like', value: filters.itemName })
    setOrFilters([])
    setAppliedSkuFilter(filters.sku || '')
    setAndFilters(appliedPickupFilters)
    handleAndFiltersChange(appliedPickupFilters);
    
    // Reset selection and combined data when filters are applied
    setRowSelectionModel([])
    setSelectedRows([])
    setCombinedData([])
  }

  const handleAndFiltersChange = (newAndFilters) => {
    refetch({
      andfilter: [...defaultFilters, ...newAndFilters]
    });
  }

  // useEffect(() => {
  //   if (data?.data?.length > 0) {
  //     const fData = data?.data?.map((row) => {
  //       const rowItems = row?.orderItems?.map((oi) => {
  //         const skuDetail = skuDetails?.find((sku) => sku.skuCode === oi.sku_id)
  //         return { ...oi, ...skuDetail }
  //       })

  //       return { ...row, orderItems: rowItems }
  //     })
  //     setFinalData(fData)
  //   } else if (data?.data?.length === 0) {
  //     setFinalData([])
  //   }

  // }, [skuDetails, data])

  const skuData = (fullfillData) => {
    setFulfilledItem(withOrderLevelDimsFallback(fullfillData?.fullfilledItems, fullfillData))
  }

  const formatOrderStatus = (status) => {
    if (!status) return '-';
    return status.replace(/_/g, ' ').toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Bulk-upload orders declare one weight/dimensions figure for the whole order (in
  // shipment_detail), not per item, so the View Items/Fulfilled Items modals - which only
  // ever see the raw item list - would otherwise show blank dashes for every row on this channel.
  const withOrderLevelDimsFallback = (items, row) => {
    const orderLevelDims = row?.shipment_detail?.[0];
    if (row?.channel !== 'BULK_UPLOAD' || !orderLevelDims) return items;
    return (items || []).map((item) => {
      if (item.item_length || item.item_breadth || item.item_height || item.weight) return item;
      return {
        ...item,
        item_length: orderLevelDims.item_length,
        item_breadth: orderLevelDims.item_breadth,
        item_height: orderLevelDims.item_height,
        weight: orderLevelDims.item_weight,
      };
    });
  };

  const columns = [
    {
      field: 'channel', sortable: true, flex: 1.3, minWidth: 175, headerAlign: "left", headerName: 'Order No',
      // Client-side sort key: order numbers are strings, so sort numerically when they
      // parse as numbers, else fall back to the raw string. Reorders the loaded page only.
      valueGetter: ({ row }) => {
        const n = Number(row.order_number)
        return Number.isNaN(n) ? (row.order_number || '') : n
      },
      renderCell: ({ row }) => {
        // Always-visible Create Shipment shortcut: a compact labeled outlined pill
        // beside the channel icon — cell stays two lines tall so the row height
        // (and every other column's vertical alignment) is unchanged. Same gating
        // as the Action column button (no cancelled orders, inactive during bulk
        // selection).
        const canCreate = !diableSelection.includes(row.channelOrderStatus) && rowSelectionModel.length === 0;
        return (
          <Box sx={cellStackSx}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              {canCreate ? (
                <Tooltip title="Create shipment">
                  <Box
                    onClick={() => setPlaceOrderFor([row])}
                    sx={{
                      display: 'inline-flex', alignItems: 'center', gap: '4px', width: 'fit-content', cursor: 'pointer',
                      color: PRIMARY_BLUE, bgcolor: withOpacity(PRIMARY_BLUE, 0.08),
                      border: `1px solid ${withOpacity(PRIMARY_BLUE, 0.24)}`, borderRadius: RADIUS.pill,
                      px: 0.75, py: 0.25,
                      '&:hover': { bgcolor: withOpacity(PRIMARY_BLUE, 0.14), borderColor: PRIMARY_BLUE },
                    }}
                  >
                    <AddCircleOutlineIcon sx={{ fontSize: 14 }} />
                    <Typography sx={{ ...primaryTextSx, color: PRIMARY_BLUE, fontWeight: WEIGHT.semibold }}>{row.order_number}</Typography>
                  </Box>
                </Tooltip>
              ) : (
                <Typography sx={primaryTextSx}>{row.order_number}</Typography>
              )}
              {row.order_number && <CopyIcon text={String(row.order_number)} title="Copy Order No" />}
            </Box>
            <Stack direction="row" spacing={0.75} alignItems="center">
              <ChannelIcon name={row.channel} />
            </Stack>
            {/* Bulk-upload orders can be either direction - the CSV's own order_type column
                decides it per row, so it isn't visible anywhere else on this list. Surface it
                right under the channel chip rather than requiring a click into the item to see it. */}
            {row.channel === 'BULK_UPLOAD' && (
              <Chip
                label={row.is_reverse ? 'Reverse' : 'Forward'}
                size="small"
                sx={{
                  height: 18, fontSize: 10, fontWeight: WEIGHT.semibold, mt: '2px', borderRadius: '4px',
                  bgcolor: row.is_reverse ? withOpacity('#ed6c02', 0.12) : withOpacity('#2e7d32', 0.12),
                  color: row.is_reverse ? '#ed6c02' : '#2e7d32',
                }}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: 'store_name', flex: 1, minWidth: 120, sortable: false, headerAlign: "left", hideSortIcons: true, headerName: 'Store Name',
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Typography sx={primaryTextSx}>{row.store_name}</Typography>
        </Box>
      ),
    },
    {
      field: 'orderName', minWidth: 100, sortable: false, headerAlign: "left", hideSortIcons: true, headerName: 'Order Name',
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Typography sx={secondaryTextSx}>{row.orderName}</Typography>
        </Box>
      ),
    },
    {
      field: 'orderConfirmationStatus', sortable: false, flex: 1, minWidth: 130, headerAlign: "left", hideSortIcons: true, headerName: 'Verification',
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Typography sx={secondaryTextSx}>WA: {row?.orderConfirmationStatus ? formatOrderStatus(row.orderConfirmationStatus) : '-'}</Typography>
          <Typography sx={secondaryTextSx}>Addr: {row?.addressVerificationStatus ? formatOrderStatus(row.addressVerificationStatus) : '-'}</Typography>
        </Box>
      ),
    },
    {
      field: 'channelOrderId', flex: 0.9, minWidth: 110, sortable: true, headerAlign: "left", headerName: 'Order Date',
      // Client-side sort key: numeric timestamp so the date column sorts chronologically.
      valueGetter: ({ row }) => (row.createdDate ? new Date(row.createdDate).getTime() : 0),
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Typography sx={primaryTextSx}>{formatDate(row.createdDate, "dd MMM, yyyy")}</Typography>
          <Typography sx={secondaryTextSx}>{formatDate(row.createdDate, "hh:mm aaa")}</Typography>
        </Box>
      ),
    },
    {
      field: 'customer', flex: 1.2, minWidth: 150, sortable: false, headerAlign: "left", hideSortIcons: true, headerName: 'Customer Details',
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Typography sx={primaryTextSx}>{row.customer?.first_name}</Typography>
          <Typography sx={secondaryTextSx}>
            {shouldMaskData(report, row, piiAccessAllow) ? maskEmail(row.customer?.email) : row.customer?.email}
          </Typography>
          <Typography sx={secondaryTextSx}>
            {shouldMaskData(report, row, piiAccessAllow) ? maskPhoneNumber(row.customer?.phone) : row.customer?.phone}
          </Typography>
          {/* NETRA scores, frozen at channel-order ingest. Both badges self-hide
              when unscored or when the merchant opted out, and open the full card
              in a dialog on click — same components /orders uses. scorePath points
              them at the channel-order read API instead of the order one. */}
          {row.netra_address && (
            <Box sx={{ mt: 0.3 }}>
              <NetraScoreBadge
                netra={row.netra_address}
                orderId={row.id}
                scorePath={`channel-order/${row.id}/netra-score`}
                scoredStageNote={netraStageNote(row.netra_address)}
              />
            </Box>
          )}
          {row.netra_rto && (
            <Box sx={{ mt: 0.3 }}>
              <RtoRiskBadge
                netra={row.netra_rto}
                orderId={row.id}
                scorePath={`channel-order/${row.id}/netra-score`}
                scoredStageNote={netraStageNote(row.netra_rto)}
              />
            </Box>
          )}
        </Box>
      ),
    },
    {
      field: 'items', flex: 0.7, minWidth: 140, sortable: false, headerAlign: "left", hideSortIcons: true, headerName: 'Items',
      renderCell: ({ row }) => {
        const items = row.orderItems || [];
        const thumbs = items.flatMap((it) => getItemImages(it));
        const shown = thumbs.slice(0, 2);
        const extra = thumbs.length - shown.length;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 1, alignItems: 'flex-start' }}>
            {shown.length > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {shown.map((src, i) => (
                  <Box key={i} component="img" src={src} alt=""
                    onClick={() => setPreviewImage(src)}
                    sx={{ width: 34, height: 34, borderRadius: '6px', objectFit: 'cover', border: `1px solid ${BORDER}`, bgcolor: '#f5f5f5', flexShrink: 0, cursor: 'zoom-in' }} />
                ))}
                {extra > 0 && (
                  <Box onClick={() => setOrderItems(withOrderLevelDimsFallback(row.orderItems, row))}
                    title="View all items"
                    sx={{ width: 34, height: 34, borderRadius: '6px', border: `1px solid ${BORDER}`, bgcolor: '#eef1f5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>
                    <Typography sx={{ fontFamily: FONT, fontSize: '11px', fontWeight: WEIGHT.semibold, color: SUBTLE }}>+{extra}</Typography>
                  </Box>
                )}
              </Box>
            )}
            <Button onClick={() => setOrderItems(withOrderLevelDimsFallback(row.orderItems, row))}
              sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0, justifyContent: 'flex-start' }}>
              View Items{items.length ? ` (${items.length})` : ''}
            </Button>
          </Box>
        );
      },
    },
    {
      field: 'paymentDetails', headerAlign: "left", sortable: false, hideSortIcons: true, headerName: 'Payment', flex: 0.9, minWidth: 110,
      renderCell: ({ row }) => {
        const paymentMode = row.payment_mode || '';
        return (
          <Box sx={cellStackSx}>
            {row.total_price && <Typography sx={primaryTextSx}>{formatCurrency(row.total_price)}</Typography>}
            {paymentMode && <Chip size="small" variant="outlined" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />}
            {row.financial_status && (
              <Chip
                size="small"
                label={row.financial_status}
                sx={{ fontFamily: FONT, fontSize: '11px', fontWeight: WEIGHT.semibold, height: 20, bgcolor: WARNING_BG, color: '#B45309', border: '1px solid #F59E0B' }}
              />
            )}
            {/* {paymentMode === 'COD' && row.cod && <Typography sx={secondaryTextSx}>COD: {formatCurrency(row.cod)}</Typography>} */}
          </Box>
        );
      },
    },
    {
      field: 'channelOrderStatus', headerAlign: "left", sortable: false, hideSortIcons: true, headerName: 'Status', flex: 1, minWidth: 155,
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Chip size="small" variant="outlined" label={_.startCase(row.channelOrderStatus)} sx={getStatusChipSx(row.channelOrderStatus)} />
        </Box>
      ),
    },
    {
      field: 'fulfilleditems', flex: 0.6, minWidth: 80, sortable: false, headerAlign: "left", hideSortIcons: true, headerName: 'Fulfilled',
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          {row.channelOrderStatus === "PARTIALLY_FULLFILLED" && row.fullfilledItems?.length > 0
            ? <Button onClick={() => skuData(row)} sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0, justifyContent: 'flex-start' }}>View Items</Button>
            : <Typography sx={secondaryTextSx}>-</Typography>}
        </Box>
      ),
    },
    {
      field: 'mesurements', headerAlign: "left", sortable: false, hideSortIcons: true, headerName: 'Weight', flex: 0.6, minWidth: 80,
      renderCell: ({ row }) => (
        <Box sx={cellStackSx}>
          <Typography sx={primaryTextSx}>{row.total_weight?.toFixed(2)} gm</Typography>
        </Box>
      ),
    },
    {
      field: 'tags', flex: 1, minWidth: 120, sortable: false, headerAlign: "left", hideSortIcons: true, headerName: 'Tags',
      renderCell: ({ row }) => {
        if (!row.tags) return null;
        const tags = row.tags.split(',').map((t) => t.trim()).filter(Boolean);
        return (
          // width:100% bounds the row to the cell so chips WRAP within the Tags column
          // (row grows taller via the grid's auto height) instead of overflowing into Action.
          <Box sx={{ ...cellStackSx, flexDirection: 'row', flexWrap: 'wrap', alignContent: 'flex-start', gap: 0.5, width: '100%', minWidth: 0 }}>
            {tags.map((t, i) => <Chip key={i} size="small" variant="outlined" label={t.toUpperCase()}
              sx={{ maxWidth: '100%', fontFamily: FONT, fontSize: 10, fontWeight: WEIGHT.semibold, height: 22, '& .MuiChip-label': { px: 0.8, overflow: 'hidden', textOverflow: 'ellipsis' } }} />)}
          </Box>
        );
      },
    },
    {
      // Same look & feel as the D2C Forward Shipments Action column: centered,
      // standard contained button + 32px paper-background ⋮ icon button.
      field: 'action', headerAlign: "center", align: "center", sortable: false, hideSortIcons: true, headerName: 'Action', flex: 1.2, minWidth: 190,
      renderCell: ({ row }) => {
        if (diableSelection.includes(row.channelOrderStatus)) return null;
        // customer.id (never PII-masked) falls back to phone/email — see
        // getCustomerIdentityFilter. Without at least one of these there's
        // nothing to look history up by, regardless of PII access.
        const { cacheKey: historyCacheKey, hasIdentity: hasContactDetails } = getCustomerIdentityFilter(row);
        // Enabled (blue) once this customer has more than just this one
        // order; greyed out & unclickable on their first order (or while the
        // history check is still in flight — defaults to "no history yet").
        const hasHistory = hasContactDetails && customerHistoryCache[historyCacheKey] === true;
        return (
          <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100%' }}>
            <Stack direction="column" spacing={0.5} alignItems="stretch">
              <Button
                variant="contained"
                size="small"
                disabled={rowSelectionModel.length > 0}
                onClick={() => setPlaceOrderFor([row])}
                sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 600, px: 2, fontSize: 12 }}
              >
                Create Shipment
              </Button>
              <Tooltip title={!hasContactDetails ? 'No customer details available to look up history' : (!hasHistory ? 'This is the customer\'s first order' : '')}>
                <span>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={rowSelectionModel.length > 0 || !hasHistory}
                    onClick={() => setHistoryRow(row)}
                    sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 600, px: 2, fontSize: 12, width: '100%' }}
                  >
                    View History
                  </Button>
                </span>
              </Tooltip>
            </Stack>
            <Tooltip title="More actions">
              <span>
                <IconButton
                  size="small"
                  disabled={rowSelectionModel.length > 0}
                  onClick={(e) => setActionMenu({ anchorEl: e.currentTarget, row })}
                  sx={{
                    bgcolor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    width: 32,
                    height: 32,
                    '&:hover': { bgcolor: 'grey.100' },
                  }}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  const resyncChannelOrder = (channelOrderId, storeName) => {
    setIsResyncing(true)
    postGeneric(`${apiConstants.RESYNC_CHANNEL_ORDER}?storeName=${storeName}&orderId=${channelOrderId}`).then((res) => {
      console.log(res)
      refetch()
      enqueueSnackbar(res?.message || 'Order resynced successfully', { variant: 'success' })
    }).catch((err) => {
      console.log(err)
      enqueueSnackbar(err.response?.data?.message || 'Order resync failed', { variant: 'error' })
    }).finally(() => {
      setIsResyncing(false)
    })
  }

  const openCancelDialog = (row) => {
    setCancelDialogRow(row)
    setCancelDialogOpen(true)
  }

  const confirmCancelOrder = () => {
    const row = cancelDialogRow
    if (!row) return
    setCancelDialogOpen(false)
    // Prepaid cancellations must be refunded; COD orders are not.
    const refund = String(row.payment_mode).toUpperCase() === 'PREPAID'
    postGeneric(`${apiConstants.CANCEL_CHANNEL_ORDER}?channelOrderId=${row.channelOrderId}&storeName=${row.store_name || ''}&reason=OTHER&refund=${refund}&notifyCustomer=false`).then((res) => {
      refetch()
      enqueueSnackbar('Order cancelled on Shopify successfully', { variant: 'success' })
    }).catch((err) => {
      enqueueSnackbar(err.response?.data?.message || 'Cancel order failed', { variant: 'error' })
    }).finally(() => {
      setCancelDialogRow(null)
    })
  }

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  // Row the "View History" button was clicked for — drives CustomerOrderHistoryModal
  const [historyRow, setHistoryRow] = useState(null);
  // Single shared row-action menu (the ⋮) — { anchorEl, row } or null
  const [actionMenu, setActionMenu] = useState(null);
  const closeActionMenu = () => setActionMenu(null);
  const runFromMenu = (fn) => () => { fn?.(); closeActionMenu(); };

  const editCustomer = (row) => {
    setSelectedRow(row);
    setIsEditModalOpen(true);
  }
  const handleClose = () => {
    setIsEditModalOpen(false)
  }


  const bulkCreateHandler = () => {
    setPlaceOrderFor(selectedRows)
  }

  // ── Release Order (unhold COD) — bulk from selectedRows, or a single order via codOnHoldOrder ──
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const [codOnHoldOrder, setCodOnHoldOrder] = useState(null)

  const setCODOnHoldFunc = () => {
    let ordersToProcess = []
    if (codOnHoldOrder) {
      ordersToProcess = [codOnHoldOrder]
    } else {
      ordersToProcess = selectedRows.filter((row) => row.isCodOnHold)
    }

    const filteredRows = ordersToProcess.map((row) => {
      return {
        channelOrderId: row.channelOrderId,
        codOnHold: false,
      }
    })

    if (filteredRows.length === 0) {
      enqueueSnackbar('No orders with COD On Hold status found', {
        variant: 'warning',
      })
      setConfirmDialogOpen(false)
      return
    }
    postGeneric(`${apiConstants.UNHOLD_COD}/${merchantId}/codOnHold`, filteredRows)
      .then((res) => {
        if (res.status === 200) {
          enqueueSnackbar(`Successfully unheld ${filteredRows.length} order(s)`, {
            variant: 'success',
          })
          setConfirmDialogOpen(false)
          setRowSelectionModel([])
          setCodOnHoldOrder(null)
          refetch()
        }
      })
      .catch((err) => {
        enqueueSnackbar(err?.message || 'Failed to unhold orders', {
          variant: 'error',
        })
      })
  }

  // ── Archive — moves the selected unfulfilled orders out of this list into the Archived tab ──
  const [archiveDialogOpen, setArchiveDialogOpen] = useState(false)
  const [isArchiving, setIsArchiving] = useState(false)

  const archiveSelectedOrders = () => {
    const channelOrderIds = selectedRows.map((row) => row.channelOrderId)
    if (channelOrderIds.length === 0) return
    setIsArchiving(true)
    postGeneric(apiConstants.ARCHIVE_CHANNEL_ORDERS, channelOrderIds)
      .then((res) => {
        const result = res?.data?.responseObj || {}
        const archivedCount = result.archived?.length || 0
        const skipped = result.skipped || []
        if (archivedCount > 0) {
          enqueueSnackbar(`${archivedCount} order${archivedCount > 1 ? 's' : ''} archived`, { variant: 'success' })
        }
        if (skipped.length > 0) {
          enqueueSnackbar(`${skipped.length} order${skipped.length > 1 ? 's' : ''} could not be archived: ${skipped[0].reason}`, { variant: 'warning' })
        }
        setArchiveDialogOpen(false)
        setRowSelectionModel([])
        setSelectedRows([])
        setCombinedData([])
        refetch()
        onArchived?.()
      })
      .catch((err) => {
        enqueueSnackbar(err.response?.data?.message || 'Could not archive the orders. Please try again.', { variant: 'error' })
      })
      .finally(() => setIsArchiving(false))
  }

  // ── Bulk Address Upload ──
  const [bulkAddressUpload, setBulkAddressUpload] = useState(false)
  const [isResultModalOpen, setIsResultModalOpen] = useState(false)
  const [uploadResults, setUploadResults] = useState([])
  const [uploadSummary, setUploadSummary] = useState({ successCount: 0, failureCount: 0, totalRows: 0 })
  const [resultPage, setResultPage] = useState(0)
  const [resultSizePerPage, setResultSizePerPage] = useState(10)

  const handleBulkAddressUpload = () => {
    setBulkAddressUpload(true)
  }
  const handleCloseBulkAddressUpload = () => {
    setBulkAddressUpload(false)
  }

  return (
    <div>
      {(isLoading || isFetching || isResyncing) && <Loader />}

      <Dialog open={archiveDialogOpen} maxWidth='xs' fullWidth onClose={() => !isArchiving && setArchiveDialogOpen(false)}>
        <DialogTitle>Archive {selectedRows.length} order{selectedRows.length > 1 ? 's' : ''}?</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            <Typography variant='body2' color='text.secondary'>
              Archived orders move to the Archived tab, where you can view them but not take any action on them.
              They are removed permanently after the retention period.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setArchiveDialogOpen(false)} disabled={isArchiving} sx={secondaryBtnSx} variant='outlined'>Cancel</Button>
          <LoadingButton onClick={archiveSelectedOrders} loading={isArchiving} variant='contained' sx={primaryBtnSx}>Archive</LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDialogOpen}
        maxWidth='md'
        onClose={() => setConfirmDialogOpen(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{''}</DialogTitle>
        <DialogContent>
          {(() => {
            let codOnHoldOrders = []
            if (codOnHoldOrder) {
              codOnHoldOrders = [codOnHoldOrder]
            } else {
              codOnHoldOrders = selectedRows.filter((row) => row.isCodOnHold)
            }
            return codOnHoldOrders.length > 0 ? (
              <>
                <DialogContentText id='alert-dialog-description'>
                  <Typography variant='subtitle1' color='text.secondary' sx={{ mb: 1 }}>
                    Are you sure you want to release the following orders from COD hold ?
                  </Typography>
                </DialogContentText>
                <Box sx={{ mt: 2, maxHeight: 500, overflow: 'auto' }}>
                  <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
                    Orders to be released from COD hold ({codOnHoldOrders.length}):
                  </Typography>
                  <Box sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 1, overflow: 'hidden' }}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', backgroundColor: 'grey.100', borderBottom: '1px solid', borderColor: 'grey.300' }}>
                      <Typography variant='body2' sx={{ p: 1, fontWeight: 600, textAlign: 'center' }}>Order Number</Typography>
                      <Typography variant='body2' sx={{ p: 1, fontWeight: 600, textAlign: 'center' }}>Order Name</Typography>
                      <Typography variant='body2' sx={{ p: 1, fontWeight: 600, textAlign: 'center' }}>Store Name</Typography>
                    </Box>
                    {codOnHoldOrders.map((order, index) => (
                      <Box key={index} sx={{
                        display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
                        borderBottom: index < codOnHoldOrders.length - 1 ? '1px solid' : 'none',
                        borderColor: 'grey.200', '&:hover': { backgroundColor: 'grey.50' },
                      }}>
                        <Typography variant='body2' sx={{ p: 1, textAlign: 'center' }}>{order.order_number}</Typography>
                        <Typography variant='body2' sx={{ p: 1, textAlign: 'center' }}>{order.orderName || '-'}</Typography>
                        <Typography variant='body2' sx={{ p: 1, textAlign: 'center' }}>{order.store_name || '-'}</Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </>
            ) : (
              <>
                <DialogContentText id='alert-dialog-description'>
                  <Typography variant='subtitle1' color='text.secondary' sx={{ mb: 1 }}>
                    No orders with COD On Hold status found in your selection.
                  </Typography>
                </DialogContentText>
                <Typography variant='body2' color='text.secondary' sx={{ mt: 2 }}>
                  Only orders that are currently on COD hold can be unheld. Please select orders
                  that have COD On Hold status and try again.
                </Typography>
              </>
            )
          })()}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmDialogOpen(false)
              setCodOnHoldOrder(null)
            }}
          >
            {(() => {
              let codOnHoldOrders = []
              if (codOnHoldOrder) {
                codOnHoldOrders = [codOnHoldOrder]
              } else {
                codOnHoldOrders = selectedRows.filter((row) => row.isCodOnHold)
              }
              return codOnHoldOrders.length > 0 ? 'Cancel' : 'Close'
            })()}
          </Button>
          {(() => {
            let codOnHoldOrders = []
            if (codOnHoldOrder) {
              codOnHoldOrders = [codOnHoldOrder]
            } else {
              codOnHoldOrders = selectedRows.filter((row) => row.isCodOnHold)
            }
            return codOnHoldOrders.length > 0 ? (
              <Button onClick={setCODOnHoldFunc}>Yes</Button>
            ) : null
          })()}
        </DialogActions>
      </Dialog>

      <Menu
        anchorEl={actionMenu?.anchorEl}
        open={Boolean(actionMenu)}
        onClose={closeActionMenu}
        PaperProps={{ sx: { minWidth: 180 } }}
      >
        <MenuItem onClick={runFromMenu(() => editCustomer(actionMenu?.row))}>
          <ListItemIcon><EditOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={runFromMenu(() => resyncChannelOrder(actionMenu?.row?.channelOrderId, actionMenu?.row?.store_name))}>
          <ListItemIcon><SyncOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Resync</ListItemText>
        </MenuItem>
        {canCancel && (
          <MenuItem onClick={runFromMenu(() => openCancelDialog(actionMenu?.row))} sx={{ color: '#dc2626' }}>
            <ListItemIcon><CancelOutlinedIcon fontSize="small" sx={{ color: '#dc2626' }} /></ListItemIcon>
            <ListItemText>Cancel Order</ListItemText>
          </MenuItem>
        )}
      </Menu>

      {/* Cancel Order Confirmation Dialog */}
      <Dialog open={cancelDialogOpen} onClose={() => setCancelDialogOpen(false)}>
        <DialogTitle>Cancel Order on Shopify</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to cancel order <strong>{cancelDialogRow?.order_number || cancelDialogRow?.channelOrderId}</strong> on Shopify?
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCancelDialogOpen(false)}>No</Button>
          <Button onClick={confirmCancelOrder} color="error" variant="contained">Yes, Cancel Order</Button>
        </DialogActions>
      </Dialog>

      <MUIModal
        open={isEditModalOpen}
        title="Edit Details"
        handleClose={() => setIsEditModalOpen(false)} children={<EditCustomerDetails handleClose={handleClose} shippingAddress={selectedRow} refetch={refetch} />}>
      </MUIModal>

      <CustomerOrderHistoryModal
        open={!!historyRow}
        onClose={() => setHistoryRow(null)}
        mobile={historyRow?.customer?.phone}
        email={historyRow?.customer?.email}
        customerId={historyRow?.customer?.id || null}
        customerName={historyRow?.customer?.first_name}
        piiAccessAllow={piiAccessAllow}
        merchantId={merchantId}
      />

      <MUIModal
        open={bulkAddressUpload ? true : false}
        title='Bulk Address Upload'
        handleClose={handleCloseBulkAddressUpload}
      >
        <BulkAddressUpload
          merchantId={merchantId}
          handleCloseBulkAddressUpload={handleCloseBulkAddressUpload}
          setUploadResults={setUploadResults}
          setUploadSummary={setUploadSummary}
          setIsResultModalOpen={setIsResultModalOpen}
        />
      </MUIModal>

      <MUIModal
        open={isResultModalOpen}
        handleClose={() => setIsResultModalOpen(false)}
        title="Upload Results"
        maxWidth="lg"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Summary: {uploadSummary.successCount} succeeded, {uploadSummary.failureCount} failed out of {uploadSummary.totalRows} total rows
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ProzoDataGrid
              columns={[
                { field: 'rowNumber', headerAlign: 'left', align: 'left', hideSortIcons: true, headerName: 'Row Number', flex: 0.5 },
                { field: 'orderNumber', headerAlign: 'left', align: 'left', hideSortIcons: true, headerName: 'Order Number', flex: 0.8 },
                { field: 'channelOrderId', headerAlign: 'left', align: 'left', hideSortIcons: true, headerName: 'Channel Order ID', flex: 1 },
                {
                  field: 'status', headerAlign: 'left', align: 'left', hideSortIcons: true, headerName: 'Status', flex: 0.6,
                  renderCell: (params) => {
                    const { row } = params
                    return <Chip label={row.status} size='small' color={row.status === 'SUCCESS' ? 'success' : 'error'} />
                  },
                },
                { field: 'message', headerAlign: 'left', align: 'left', hideSortIcons: true, headerName: 'Message', flex: 1.5 },
              ]}
              rows={uploadResults || []}
              sizePerPage={resultSizePerPage}
              setSizePerPage={setResultSizePerPage}
              setPage={setResultPage}
              page={resultPage}
              pagination={true}
              hideFooterPagination={false}
              paginationMode="client"
              rowCount={uploadResults?.length || 0}
              getRowId={(row) => row.id}
            />
          </Grid>
        </Grid>
      </MUIModal>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box data-rp-filters sx={filterBarSx}>
            <FormProvider methods={methods} onSubmit={handleSubmit(applyPickupFilters)}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={3}>
                  <RHFTextField name="order_number" label="Order Number (Comma Separated)" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <RHFTextField name="order_name" label="Order Name (Comma Separated)" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFSelectField label="Payment Mode" name="payment_mode"
                    options={[{ label: "COD", value: 'COD' }, { label: "PREPAID", value: 'PREPAID' }]} width="100%" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFSelectField label="WA Verification" name="orderConfirmationStatus"
                    options={[
                      { label: "Not Subscribed", value: 'NOT_SUBSCRIBED' },
                      { label: "Sent", value: 'SENT' },
                      { label: "Delivered", value: 'DELIVERED' },
                      { label: "Order Confirmed", value: 'ORDER_CONFIRMED' },
                      { label: "Order Cancelled", value: 'ORDER_CANCELLED' }]}
                    width="100%" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFSelectField label="Addr Verification" name="addressVerificationStatus"
                    options={[
                      { label: "Not Subscribed", value: 'NOT_SUBSCRIBED' },
                      { label: "Sent", value: 'SENT' },
                      { label: "Delivered", value: 'DELIVERED' },
                      { label: "Address Updated", value: 'ADDRESS_UPDATED' },
                      { label: "No Change Required", value: 'NO_CHANGE_REQUIRED' },
                      { label: "Address Update Failed", value: 'ADDRESS_UPDATE_FAILED' }]}
                    width="100%" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="email" label="Customer Email" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="phone" label="Customer Phone" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="store_name" label="Store Name" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="tagsValue" label="Tags" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFDateRangePickerField label="Order Date" maxDate={new Date()} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="sku" label="SKU" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="itemName" label="Item Name" />
                </Grid>
                <WeightRangeFields />
                <Grid item xs={12}>
                  <Box sx={btnRowSx}>
                    <Button type="submit" variant="contained" sx={primaryBtnSx}>Filter</Button>
                    <Button variant="outlined" sx={secondaryBtnSx} onClick={() => {
                      reset()
                      setAndFilters([])
                      setOrFilters([])
                      setAppliedSkuFilter('')
                      setRowSelectionModel([])
                      setSelectedRows([])
                      setCombinedData([])
                    }}>Reset</Button>
                  </Box>
                </Grid>
              </Grid>
            </FormProvider>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Stack direction='row' sx={{ mb: 1, justifyContent: 'space-between', alignItems: 'center' }}>
            <Stack direction='row' spacing={1} alignItems='center'>
              <Button variant='contained'
                onClick={handleBulkAddressUpload}
                startIcon={<UploadFileOutlined />}
                sx={primaryBtnSx}
              >
                Bulk Address Upload
              </Button>
              <ChannelOrderExportButton
                filename={`channel_orders_${canceled ? 'cancelled' : 'new'}`}
                visibleRows={data?.data || []}
                selectedRows={selectedRows}
                selectedCount={rowSelectionModel.length}
              />
            </Stack>
            <Stack direction='row'>
              {!canceled && (
                <Button
                  disabled={rowSelectionModel.length === 0}
                  onClick={() => setArchiveDialogOpen(true)}
                  variant='outlined'
                  sx={{ ...secondaryBtnSx, mr: 1 }}
                  startIcon={<ArchiveOutlinedIcon />}
                >
                  Archive
                </Button>
              )}
              <Button
                disabled={rowSelectionModel.length === 0 || selectedRows.filter((row) => row.isCodOnHold).length === 0}
                onClick={() => { setConfirmDialogOpen(true) }}
                variant='outlined'
                sx={{ ...secondaryBtnSx, mr: 1 }}
                startIcon={<TaskAltIcon />}
              >
                Release Order
              </Button>
              <Button disabled={rowSelectionModel.length === 0} onClick={bulkCreateHandler}
                variant='contained' startIcon={<CheckCircleIcon />} sx={primaryBtnSx}>
                Create Shipment
              </Button>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <ProzoDataGrid
            columns={columns}
            rows={data?.data || []}
            sizePerPage={sizePerPage}
            setSizePerPage={setSizePerPage}
            setPage={setPage}
            page={page}
            checkboxSelection
            keepNonExistentRowsSelected={true}
            isRowSelectable={({ row }) => !diableSelection.includes(row.channelOrderStatus)}
            rowSelectionModel={rowSelectionModel}
            setRowSelectionModel={setRowSelectionModel}
            pagination={true}
            hideFooterPagination={false}
            filterMode={"server"}
            rowCount={data?.count}
            getRowId={(row) => row?.id}
            sortingMode="client"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
          />
        </Grid>
      </Grid>
      <PlacedOrderForContext.Provider value={{ placeOrderFor, setPlaceOrderFor }}>
        <MerchantContext.Provider value={{ merchant, setMerchant }}>
          <PlaceOrderModal
            refetch={refetch}
            data={data}
            merchantId={merchantId}
            piiAccessAllow={piiAccessAllow}
            report={report}
            setRowSelectionModel={setRowSelectionModel}
            setCombinedData={setCombinedData}
            appliedSkuFilter={appliedSkuFilter}
          />
        </MerchantContext.Provider>
      </PlacedOrderForContext.Provider>

      <MUIModal
        open={orderItems ? true : false}
        maxWidth='md'
        title="Order Items"
        handleClose={() => setOrderItems(null)}
      >
        <ProzoDataGrid
          columns={[
            {
              field: 'image', headerName: 'Image', sortable: false, flex: 1, minWidth: 130,
              renderCell: ({ row }) => {
                const imgs = getItemImages(row);
                if (!imgs.length) return <Typography sx={secondaryTextSx}>—</Typography>;
                return (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: 0.5 }}>
                    {imgs.map((src, i) => (
                      <Box key={i} component="img" src={src} alt={row.title || ''}
                        onClick={() => setPreviewImage(src)}
                        sx={{ width: 56, height: 56, borderRadius: '8px', objectFit: 'cover', border: `1px solid ${BORDER}`, cursor: 'zoom-in' }} />
                    ))}
                  </Box>
                );
              },
            },
            { field: 'sku_id', headerName: 'SKU', sortable: false, flex: 1 },
            { field: 'title', headerName: 'Name', sortable: false, flex: 1.5 },
            { field: 'selling_price', headerName: 'Price', sortable: false, flex: 1 },
            { field: 'units', headerName: 'Quantity', sortable: false, flex: 1 },
            {
              field: 'tax', headerName: 'Tax(%)', sortable: false, flex: 1, renderCell: ({ row }) => {
                return _.sumBy(row.taxlines, function (tax) {
                  return tax.rate
                })
              }
            },
            {
              field: 'dimensions', headerName: 'Dimensions/Weight', sortable: false, flex: 1.5, renderCell: ({ row }) => {
                let w = row.weight ? formatNumber(row.weight / 1000) + ' kg' : ''
                return (
                  <Box>
                    <Typography textAlign="center" variant="body2">{[row.item_length, row.item_breadth, row.item_height].join(' x ')}</Typography>
                    <Typography variant="body2" textAlign="center" fontWeight={500}>{w}</Typography>
                  </Box>
                )
              }
            },
          ]}
          rows={orderItems || []}
          boxShadow={0}
          hideFooterPagination
          rowCount={orderItems?.length || 0}
          getRowId={(row) => row.id}
        />
      </MUIModal>

      <MUIModal
        open={!!previewImage}
        maxWidth='md'
        title="Image Preview"
        handleClose={() => setPreviewImage(null)}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1 }}>
          <Box component="img" src={previewImage} alt=""
            sx={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', borderRadius: '8px' }} />
        </Box>
      </MUIModal>
      <MUIModal
        open={fulfilledItem ? true : false}
        title="Order Items"
        handleClose={() => setFulfilledItem(null)}
      >
        <ProzoDataGrid
          columns={[
            { field: 'sku_id', headerName: 'SKU', sortable: false, flex: 0.8, },
            {
              field: 'awbNumber', headerName: 'AWB Number', sortable: false, flex: 0.8, renderCell: ({ row }) => {
                const awb = row?.lastfulfilledUnits?.awbNumber
                return awb ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>{awb}<CopyIcon text={awb} /></span> : ''
              }
            },
            { field: 'title', headerName: 'Name', sortable: false, flex: 0.8 },
            { field: 'selling_price', headerName: 'Price', sortable: false, flex: 0.8 },
            { field: 'units', headerName: 'Total Quantity', sortable: false, flex: 0.8 },
            {
              field: 'skuCount', headerName: 'Fullfilled Quantity', sortable: false, flex: 0.8, renderCell: ({ row }) => {
                return row?.lastfulfilledUnits?.skuCount
              }
            },
            {
              field: 'tax', headerName: 'Tax(%)', sortable: false, flex: 0.8, renderCell: ({ row }) => {
                return _.sumBy(row.taxlines, function (tax) {
                  return tax.rate
                })
              }
            },
            {
              field: 'dimensions', headerName: 'Dimensions/Weight', sortable: false, width: 150, renderCell: ({ row }) => {
                let w = row.weight ? formatNumber(row.weight / 1000) + ' kg' : ''
                return (
                  <Box>
                    <Typography textAlign="center" variant="body2">{[row.item_length, row.item_breadth, row.item_height].join(' x ')}</Typography>
                    <Typography variant="body2" textAlign="center" fontWeight={500}>{w}</Typography>
                  </Box>
                )
              }
            },
          ]}
          rows={fulfilledItem?.length > 0 ? fulfilledItem.map((val, index) => ({ ...val, id: index })) : []}
          boxShadow={0}
          hideFooterPagination
          rowCount={fulfilledItem?.length || 0}
          getRowId={(row) => row.id}
        />
      </MUIModal>
    </div>
  );
};



function PlaceOrderModal({ refetch, data, merchantId, piiAccessAllow, report, setRowSelectionModel, setCombinedData, appliedSkuFilter }) {
  const { placeOrderFor, setPlaceOrderFor } = React.useContext(PlacedOrderForContext)
  const { merchant } = React.useContext(MerchantContext)
  const [selectedRows, setSelectedRows] = React.useState([])
  const [selectedQuantities, setSelectedQuantities] = useState({});
  const { blendedData } = useSelector(state => state?.report);
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);

  const { data: allCouriers } = useGetCouriersQuery()
  const [isCreating, setIsCreating] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [newCourier, setNewCourier] = useState([])

  const pickupLocations = (merchant?.pickup_details || []).filter(pl => pl.status === "ACTIVE")
  const defaultPickupLocation = pickupLocations.find(pl => pl.is_default)

  // Master packaging list — lets brands pick a packaging configuration before manifest.
  const { data: packageList } = useGenericPostRequestQuery({
    url: apiConstants.GET_PACKAGES,
    method: 'GET',
    data: { merchantOid: getMerchant().id },
  })

  const method = useForm({
    resolver: yupResolver(Yup.object().shape({
      pickupLocation: Yup.string().required("Please select pickup location!"),
      rtoLocation: rtoLocationRule(Yup),
      courierPartner: Yup.string(),
    })),
    defaultValues: {
      pickupLocation: "",
      courierPartner: "",
      courierType: 'auto',
      package: '',
      ...RTO_DEFAULT_VALUES,
    }
  })

  useEffect(() => {
    if (placeOrderFor.length === 1) {
      if (placeOrderFor[0].channel === "WOO_COMMERCE") {
        setSelectedRows(placeOrderFor[0]?.orderItems?.map(oi => oi?.id))
      }
    }
  }, [placeOrderFor])

  const { handleSubmit, watch, setValue, reset: resetForm } = method

  React.useEffect(() => {
    setValue("pickupLocation", defaultPickupLocation?.id || "")
  }, [setValue, defaultPickupLocation])

  const [orderResponses, setOrderResponses] = useState([])
  const [orderRespModal, setOrderResModal] = useState(false)

  const placeOrder = async (data) => {
    setIsCreating(true)
    // In bulk mode with a SKU filter active, skip orders that contain items with other SKUs.
    const mixedIds = new Set(mixedSkuOrders.map(o => o.channelOrderId))
    const channelOrders = placeOrderFor.filter(o => !mixedIds.has(o.channelOrderId))
    // Results are written by index rather than appended, so the summary grid stays in the order
    // the merchant selected the orders in even though they now complete out of order.
    const results = new Array(channelOrders.length)

    const processOrder = async (channelOrder, idx) => {
        try {
          const pickup_details = pickupLocations.find((p) => p.id === data.pickupLocation)
          let fullfilableItems = [];

          if (placeOrderFor.length === 1) {
            fullfilableItems = channelOrder?.orderItems.filter((item) => selectedRows.includes(item.id))
          } else {
            fullfilableItems = [...(channelOrder?.orderItems || [])]
          }

          fullfilableItems = fullfilableItems?.map((item) => {
            let k = { ...item }
            // if (!k.sku_id) {
            //   let v = k.variant_id ? k.variant_id : '';
            //   k.sku_id = "SKU " + v;
            //   return k;
            // }

            return k;

          })

          fullfilableItems = fullfilableItems.map((item) => ({
            ...item,
            fulfillable_quantity: selectedQuantities[item.id] !== undefined ? selectedQuantities[item.id] : item.fulfillable_quantity
          }));

          const request = {
            pickup_details: {
              from_city: pickup_details?.city,
              from_country: pickup_details?.country,
              from_name: pickup_details?.name,
              from_state: pickup_details?.state,
              from_phone_number: pickup_details?.contactNumber,
              from_email: pickup_details?.email,
              gstin: pickup_details?.gstin,
              from_addresstype: 'PICKUP',
              from_address: pickup_details?.address_line,
              from_pincode: pickup_details?.pincode,
            },
            courier_id: data.courierType === "auto" ? null : data.courierPartner,
            channelOrderId: channelOrder.channelOrderId,
            // Omitted (not hardcoded to Forward Shipment) so the backend falls back to each order's
            // own staged order_type (SelectorCreateRequest#getOrder_type() -> ChannelOrder#getOrderType()
            // in ShopifySelectorAdapter/BulkUploadSelectorAdapter) — required for Reverse orders, which
            // this hardcode was silently flipping to Forward on every shipment creation.
            channel: channelOrder.channel,
            fullfilableItems
          }
          if (data.package) {
            request.packageId = data.package
          }
          // Optional RTO address: only sent when the merchant picked a different one.
          const return_details = buildReturnDetails(data, pickupLocations)
          if (return_details) {
            request.return_details = return_details
          }
          //if (fullfilableItems.length === 1) request.fullfilableItems = fullfilableItems
          // return false;
          const response = await postGeneric(apiConstants.CREATE_SELECTOR, request)
          results[idx] = { id: channelOrder.channelOrderId, order_number: channelOrder.order_number, status: 'Success', message: "Order Successfully Placed", awb: response?.data?.responseObj?.awb_number }
        } catch (apiError) {
          results[idx] = { id: channelOrder.channelOrderId, order_number: channelOrder.order_number, status: 'Failed', message: apiError?.response?.data?.exception?.message || "Unknown Error" }
          console.error("API Error for order:", apiError);
          // enqueueSnackbar(apiError?.response?.data?.exception?.message || `Order ${channelOrder.channelOrderId} Couldn't be Placed`, { variant: 'error' });
        }
    }

    try {
      // Sliding-window concurrency pool: keeps CHANNEL_ORDER_BATCH_SIZE requests in flight at all
      // times — each worker picks up the next order as soon as its current one resolves, rather
      // than waiting for a whole batch to finish. Replaces a strictly sequential loop, which made
      // bulk fulfilment take (orders x ~650ms) end to end.
      let cursor = 0
      const runWorker = async () => {
        while (cursor < channelOrders.length) {
          const idx = cursor++
          await processOrder(channelOrders[idx], idx)
        }
      }
      const workerCount = Math.min(CHANNEL_ORDER_BATCH_SIZE, channelOrders.length)
      await Promise.all(Array.from({length: workerCount}, runWorker))
      setOrderResponses(results.filter(Boolean))
      // enqueueSnackbar("Order Successfully Placed", { variant: 'success' });

    } catch (_err) {
      console.log(_err)
      enqueueSnackbar(_err?.response?.data?.exception?.message || "Order Couldn't be Placed", { variant: 'error' });
    } finally {
      setPlaceOrderFor([])
      setSelectedRows([])
      setRowSelectionModel([])
      setCombinedData([])
      setOrderResModal(true)
      refetch()
      setSelectedQuantities({});
    }
    setIsCreating(false)
  }
  const courierSelection = watch('courierType')
  const pickupLocation = watch('pickupLocation')
  const selectedPackageId = watch('package')

  const [isPriceLoading, setIspriceLoading] = useState(false)

  useEffect(() => {
    const pickup_details = pickupLocations.find((p) => p.id === pickupLocation);
    let orderList = [];

    for (let i = 0; i < selectedRows?.length; i++) {
      // filteredRows (not the raw orderItems) carries the order-level shipment_detail fallback for
      // BULK_UPLOAD orders - those never have per-item dimensions, so reading orderItems directly sent
      // length/breadth/height as 0 to the rate calculator, which rejected it as missing and silently
      // left the courier dropdown empty (the .catch below only logs, it never surfaces the 400).
      orderList = filteredRows?.filter((item) => item.id === selectedRows[i])
    }

    let length = _.sumBy(orderList, "item_length")
    let breadth = _.sumBy(orderList, "item_breadth")
    let height = _.sumBy(orderList, "item_height")
    let weight = _.sumBy(orderList, "weight")
    // When a master package is selected, use its dimensions for the rate calc.
    if (selectedPackageId) {
      const selectedPackage = packageList?.find((pkg) => pkg.id === selectedPackageId)
      if (selectedPackage) {
        length = selectedPackage.length_cm
        breadth = selectedPackage.breadth_cm
        height = selectedPackage.height_cm
      }
    }
    if (pickup_details) {
      setIspriceLoading(true)
      post(`${apiConstants.BASE_LOCAL}${apiConstants.SHIPMENT_RATE_CALCULATOR}`, {
        orderType: "FORWARD",
        to: parseInt(placeOrderFor[0]?.shipping_address?.zip),
        from: parseInt(pickup_details?.pincode),
        paymentType: placeOrderFor[0]?.payment_mode.toLowerCase() === "prepaid" ? "PREPAID" : "COD",
        "length": length,
        "breadth": breadth,
        "height": height,
        "weight": weight ? weight : 0.1,
        "dispatchMode": "SURFACE",
        "codAmount": placeOrderFor[0]?.cod || 0,
        "isMerchant": true,
        onlyCouriersAsPerRuleMapping: true, checkServiceable: true,
        merchantOid: merchantId,
        invoiceValue: placeOrderFor[0]?.invoice_value

      }).then((res) => {
        const pricing = res?.data;
        const newCourier = allCouriers?.map((d) => {
          const updatedCourier = { ...d };
          pricing.forEach((t) => {
            if (t.provider.id === updatedCourier.prozoId) {
              updatedCourier.priceAfterTax = t.priceAfterTax;
              updatedCourier.providerMinTatDays = t.providerMinTatDays;
              updatedCourier.providerMaxTatDays = t.providerMaxTatDays;
              updatedCourier.parent = t.provider?.parent;
              updatedCourier.providerDispatchMode = t.provider?.dispatch_mode;
              updatedCourier.providerServiceTypePrimary = t.provider?.service_type_primary;
            }
          });
          return updatedCourier;
        })
        let filteredCouriers = newCourier.filter(item =>
          item.priceAfterTax &&
          item.type === 'FORWARD'
        )
        // Deduplicate by parent + dispatch mode — keep the cheapest entry per combination
        const parentMap = new Map()
        filteredCouriers.forEach(c => {
          const key = (c.parent || c.name) + '|' + (c.providerDispatchMode || '')
          const existing = parentMap.get(key)
          if (!existing || c.priceAfterTax < existing.priceAfterTax) {
            parentMap.set(key, c)
          }
        })
        filteredCouriers = Array.from(parentMap.values())
        const now = new Date();
        filteredCouriers.forEach(shipment => {
          let minTatDays = shipment.providerMinTatDays || 0;
          let maxTatDays = shipment.providerMaxTatDays || 0;
          shipment.minDeliveryDate = format(addDays(now, minTatDays), 'dd, MMM');
          shipment.maxDeliveryDate = format(addDays(now, maxTatDays), 'dd, MMM');
        });
        setNewCourier(filteredCouriers);
        // setNewCourier(newCourier)
      }).catch((err) => console.log(err)).finally(() => setIspriceLoading(false))

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickupLocation, selectedRows, JSON.stringify(placeOrderFor), selectedPackageId])


  const RenderEditCell = ({ row }) => {
    const apiRef = useGridApiContext()
    const updaeDimensions = (e, row) => {
      e.preventDefault()
      const item_length = e.target.l.value
      const item_breadth = e.target.b.value
      const item_height = e.target.h.value
      const weight = e.target.w.value
      const orderDetails = placeOrderFor[0]
      const orderItems = orderDetails?.orderItems?.map((oi) => {
        if (oi.id !== row.id) return oi
        return { ...oi, item_length, item_breadth, item_height, weight }
      })

      setPlaceOrderFor([{ ...orderDetails, orderItems }])
      apiRef.current.stopCellEditMode({ id: row.id, field: 'dimensions' })
    }



    const dimFieldSx = {
      '& .MuiInputBase-input': { fontFamily: FONT, fontSize: SIZE['2xs'], textAlign: 'center', py: '8px', px: '6px' },
      '& .MuiInputLabel-root': { fontFamily: FONT, fontSize: 10 },
      '& .MuiOutlinedInput-root': { borderRadius: '8px' },
    }
    return (
      <form onSubmit={(e) => updaeDimensions(e, row)} style={{width: '100%'}}>
        <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
          {/* Dimensions row */}
          <Typography sx={{ fontFamily: FONT, fontSize: '0.65rem', fontWeight: WEIGHT.semibold, color: SUBTLE, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Dimensions (cm)
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <TextField required type="number" label="L" name="l" size='small' defaultValue={row.item_length} sx={dimFieldSx} InputProps={{inputProps: {min: 1}}} />
            <Typography sx={{ color: SUBTLE, fontSize: 11, flexShrink: 0 }}>×</Typography>
            <TextField required type="number" label="B" name="b" size='small' defaultValue={row.item_breadth} sx={dimFieldSx} InputProps={{inputProps: {min: 1}}} />
            <Typography sx={{ color: SUBTLE, fontSize: 11, flexShrink: 0 }}>×</Typography>
            <TextField required type="number" label="H" name="h" size='small' defaultValue={row.item_height} sx={dimFieldSx} InputProps={{inputProps: {min: 1}}} />
          </Box>
          {/* Weight row */}
          <Typography sx={{ fontFamily: FONT, fontSize: '0.65rem', fontWeight: WEIGHT.semibold, color: SUBTLE, textTransform: 'uppercase', letterSpacing: '0.5px', mt: 0.25 }}>
            Weight (grams)
          </Typography>
          <TextField required type="number" label="Weight" name="w" size='small' defaultValue={row.weight} sx={{ ...dimFieldSx, maxWidth: 120 }} InputProps={{inputProps: {min: 0}}} />
          {/* Save */}
          <Button type="submit" fullWidth variant="contained" size="small" sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, textTransform: 'none', borderRadius: '8px', mt: 0.5 }}>
            Save
          </Button>
        </Box>
      </form>
    )
  }


  const handleQuantityChange = (rowId, newValue) => {
    setSelectedQuantities(prevState => ({
      ...prevState,
      [rowId]: newValue
    }));
  };

  const fullFillableTableColumns = [
    {
      field: 'sku_id',
      headerName: 'SKU',
      sortable: false,
      flex: 1,
      editable: true,
    },
    {
      field: 'variant_id',
      headerName: 'Variant ID',
      sortable: false,
      flex: 0.8,
    },
    {
      field: 'title',
      headerName: 'Name',
      sortable: false,
      flex: 1.5,
      renderCell: ({ row }) => {
        let title = row.title;
        let variant = row.variant_title ? '( Variant: ' + row.variant_title + ' )' : '';
        return (
          <div>
            <div>{title}</div>
            <div style={{ whiteSpace: 'pre-line' }}>{variant}</div>
          </div>
        );
      },
    },
    { field: 'selling_price', headerName: 'Price', sortable: false, flex: 0.8 },
    {
      field: 'tax',
      headerName: 'Tax(%)',
      sortable: false,
      flex: 0.8,
      renderCell: ({ row }) => {
        return _.sumBy(row.taxlines, function (tax) {
          return tax.rate;
        });
      },
    },
    {
      field: 'dimensions',
      editable: true,
      headerName: 'Dimensions/Weight',
      sortable: false,
      flex: 1.2,
      renderEditCell: ({ row }) => <RenderEditCell row={row} />,
      renderCell: ({ row }) => {
        return (
          <Box>
            <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>
              {[row.item_length, row.item_breadth, row.item_height].join(' × ')} cm
              <Typography component='span' sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, color: NAVY, ml: 1 }}>
                ({formatNumber(row.weight / 1000)} kg)
              </Typography>
            </Typography>
            <Typography sx={{ fontFamily: FONT, fontSize: '0.6rem', color: SUBTLE, fontStyle: 'italic' }}>
              Double click to edit
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'fulfillable_quantity',
      headerName: 'Quantity',
      sortable: false,
      flex: 0.8,
      renderCell: ({ row }) => {
        const options = generateQuantityOptions(row.fulfillable_quantity);
        const selectedQuantity = selectedQuantities[row.id] !== undefined ? selectedQuantities[row.id] : row.fulfillable_quantity;
        return (
          <>
            {placeOrderFor[0]?.channel !== "WOO_COMMERCE" ?
              (<Select
                value={selectedQuantity}
                onChange={(event) => { handleQuantityChange(row.id, event.target.value) }}
                sx={{ width: 80, height: 36, fontFamily: FONT, fontSize: SIZE['2xs'] }}
              >
                {options.map(option => (
                  <MenuItem key={option.value} value={option.value} sx={{ fontFamily: FONT, fontSize: SIZE['2xs'] }}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>)
              :
              (<Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>{row.fulfillable_quantity}</Typography>)}
          </>
        );
      }
    },
  ];

  const fullFilledTableColumns = [
    {
      field: 'sku_id',
      headerName: 'SKU',
      sortable: false,
      flex: 1,
    },
    {
      field: 'title',
      headerName: 'Name',
      sortable: false,
      flex: 1.2,
      renderCell: ({ row }) => {
        let title = row.title;
        let variant = row.variant_title ? '( Variant: ' + row.variant_title + ' )' : '';
        return (
          <div>
            <div>{title}</div>
            <div style={{ whiteSpace: 'pre-line' }}>{variant}</div>
          </div>
        );
      },
    },
    { field: 'selling_price', headerName: 'Price', sortable: false, flex: 0.8 },
    {
      field: 'fulfilledQuantity',
      headerName: 'Fullfilled Quantity',
      sortable: false,
      flex: 0.8,
      renderCell: ({ row }) => {
        const lastFulfilledQuantity = row?.lastfulfilledUnits
        return lastFulfilledQuantity ? lastFulfilledQuantity?.skuCount : 0;
      }
    },
    {
      field: 'tax',
      headerName: 'Tax(%)',
      sortable: false,
      flex: 0.8,
      renderCell: ({ row }) => {
        return _.sumBy(row.taxlines, function (tax) {
          return tax.rate;
        });
      },
    },
    {
      field: 'dimensions',
      editable: true,
      headerName: 'Dimensions/Weight',
      sortable: false,
      flex: 1.2,
      renderEditCell: ({ row }) => <RenderEditCell row={row} />,
      renderCell: ({ row }) => {
        return (
          <Box>
            <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>
              {[row.item_length, row.item_breadth, row.item_height].join(' × ')} cm
              <Typography component='span' sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, color: NAVY, ml: 1 }}>
                ({formatNumber(row.weight / 1000)} kg)
              </Typography>
            </Typography>
            {row.weight ? (
              <Typography sx={{ fontFamily: FONT, fontSize: '0.6rem', color: SUBTLE, fontStyle: 'italic' }}>
                Double click to edit
              </Typography>
            ) : (
              <Typography sx={{ fontFamily: FONT, fontSize: '0.6rem', color: 'red', fontStyle: 'italic' }}>
                Please update weight before creating shipment
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: 'awb',
      headerName: 'AWB Number',
      sortable: false,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <>
            {row?.lastfulfilledUnits ?
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
                <Link target='_blank' style={{ color: "#3783e7", textDecoration: "underline" }} to={`/order-detail?waybill=${row?.lastfulfilledUnits?.awbNumber}`}>
                  {row?.lastfulfilledUnits?.awbNumber}
                </Link>
                <CopyIcon text={row?.lastfulfilledUnits?.awbNumber} />
              </span> : "-"}
          </>
        )
      },
    },
  ];


  const generateQuantityOptions = (currentQuantity) => {
    const options = [];
    for (let i = currentQuantity; i >= 1; i--) {
      options.push({ label: `${i}`, value: i });
    }
    return options;
  };

  // Bulk-upload orders declare one weight/dimensions figure for the whole order (in
  // shipment_detail), not per item - BulkUploadSelectorAdapter already uses that order-level
  // figure to build the real shipment regardless of what this grid shows or what gets typed
  // into its (otherwise inapplicable) per-item edit fields. Without this fallback, every item
  // row here would just show blank dashes since orderItems never carries item_length/
  // item_breadth/item_height/weight for this channel.
  const orderLevelShipmentDetail = placeOrderFor?.[0]?.shipment_detail?.[0]
  const filteredRows = placeOrderFor?.[0]?.orderItems?.filter(
    (item) => !item?.fullfilled && item.fulfillable_quantity > 0
  ).map((item) => {
    if (placeOrderFor?.[0]?.channel !== 'BULK_UPLOAD' || item.item_length || item.item_breadth || item.item_height || item.weight) {
      return item
    }
    return {
      ...item,
      item_length: orderLevelShipmentDetail?.item_length,
      item_breadth: orderLevelShipmentDetail?.item_breadth,
      item_height: orderLevelShipmentDetail?.item_height,
      weight: orderLevelShipmentDetail?.item_weight,
    }
  });

  // In bulk mode: orders that have items with SKUs other than the searched SKU must be skipped.
  const mixedSkuOrders = React.useMemo(() => {
    if (!appliedSkuFilter || placeOrderFor.length <= 1) return []
    return placeOrderFor.filter(order =>
      order.orderItems?.some(item => item.sku_id !== appliedSkuFilter)
    )
  }, [placeOrderFor, appliedSkuFilter])

  return (
    <React.Fragment>
      <MUIModal
        maxWidth="lg"
        open={orderRespModal}
        title="Order Response"
        handleClose={() => {
          setOrderResModal(false)
        }}
        children={
          <ProzoDataGrid
            columns={[
              {
                field: 'id',
                headerName: 'Order ID',
                flex: 0.6
              },
              {
                field: 'order_number',
                headerName: 'Order No.',
                flex: 0.5
              },
              {
                field: 'status',
                headerName: 'Status',
                flex: 0.5,
                renderCell: (col) => {
                  return (
                    <Box
                      sx={{
                        color: col.row?.status === 'Success' ? 'green' : 'red',
                      }}
                    >
                      {col.row?.status}
                    </Box>
                  )
                }
              },
              {
                field: 'awb',
                headerName: 'AWB Number',
                flex: 0.7,
                renderCell: (col) => {
                  return col.row?.awb ? (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
                      <Link target='_blank' style={{ color: "#3783e7", textDecoration: "underline" }} to={`/order-detail?waybill=${col.row.awb}`}>
                        {col.row.awb}
                      </Link>
                      <CopyIcon text={col.row.awb} />
                    </span>
                  ) : '-'
                }
              },
              {
                field: 'message',
                headerName: 'Response Message',
                flex: 1.5,
                renderCell: (col) => {
                  return (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        {col.row?.message}
                      </Grid>
                    </Grid>
                  )
                }
              },
            ]}
            getRowId={(row) => Math.random()}
            rows={orderResponses || []}
            sizePerPage={sizePerPage}
            setSizePerPage={setSizePerPage}
            setPage={setPage}
            page={page}
            pagination={true}
            paginationMode={'client'}
          />
        }
      />
      <MUIModal
        maxWidth="lg"
        open={placeOrderFor.length > 0 ? true : false}
        title="Create Shipment"
        handleClose={() => {
          setPlaceOrderFor([])
          resetForm()
        }}
      >
        {mixedSkuOrders.length > 0 && (
          <Alert severity="warning" sx={{ mb: 2, fontSize: 12 }}>
            <strong>{mixedSkuOrders.length} order{mixedSkuOrders.length > 1 ? 's' : ''} will be skipped</strong> — {mixedSkuOrders.length > 1 ? 'they contain' : 'it contains'} items with other SKUs alongside <strong>{appliedSkuFilter}</strong>:{' '}
            {mixedSkuOrders.map(o => o.order_number).join(', ')}
          </Alert>
        )}
        <Box sx={{ mb: 4, mt: 1, maxHeight: 300, overflow: 'auto', border: '1px solid #e0e0e0', borderRadius: 1 }}>
          <Accordion >
            <AccordionSummary expandIcon={<ExpandMoreOutlined />} aria-controls="panel1-content"
              id="panel1-header"
              sx={{ backgroundColor: '#3783e71a' }}
            >
              {/* <Box sx={{ backgroundColor: '#3783e71a', borderRadius: 1, p: 1, border: '1px solid #ccc' }}> */}
              <Typography variant="subtitle1">
                Fullfilled Items
              </Typography>
              {/* </Box> */}
            </AccordionSummary>
            <AccordionDetails>
              {placeOrderFor && placeOrderFor?.length !== 1 ? "No data" : (
                <ProzoDataGrid
                  columns={fullFilledTableColumns}
                  rows={placeOrderFor[0]?.fullfilledItems ? placeOrderFor[0]?.fullfilledItems.map((val, index) => ({ ...val, id: index })) : []}
                  boxShadow={0}
                  paginationMode="client"
                  hideFooterPagination
                  rowCount={(placeOrderFor[0]?.fullfilledItems && placeOrderFor[0]?.fullfilledItems?.length) || 0}
                  getRowId={(row) => row?.id}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
        {placeOrderFor?.length === 1 && (
          <Box sx={{ mb: 1 }}>
            <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }}>Items Available for Fulfillment</Typography>
            <ProzoDataGrid
              columns={fullFillableTableColumns}
              rows={filteredRows}
              experimentalFeatures={{ newEditingApi: true }}
              boxShadow={0}
              checkboxSelection={placeOrderFor && placeOrderFor[0] && placeOrderFor[0]?.channel !== 'WOO_COMMERCE'}
              paginationMode="client"
              onSelectionModelChange={(_ids) => setSelectedRows(_ids)}
              hideFooterPagination
              rowCount={filteredRows?.length}
            //getRowId={(row) => row?.id || row.sku}
            />
          </Box>
        )}
        <Grid container spacing={0}>
          <Grid item xs={2}>
            <Box sx={{ mb: 1 }}>
              <Typography variant="subtitle" fontWeight={500} sx={{ mb: 1 }}>Delivery Address</Typography>
            </Box>
          </Grid>
          <Grid item xs={10}>
            <Box sx={{ mb: 1 }}>
              <Typography variant="subtitle" fontWeight={500} sx={{ mb: 1 }}>
                {placeOrderFor[0]?.shipping_address?.address1},
                {placeOrderFor[0]?.shipping_address?.address2},
                {placeOrderFor[0]?.shipping_address?.city},
                {placeOrderFor[0]?.shipping_address?.state
                  ||
                  placeOrderFor[0]?.shipping_address?.province},
                {placeOrderFor[0]?.shipping_address?.zip}
                {/* {shouldMaskData(report, placeOrderFor[0]?.shipping_address, piiAccessAllow) ? maskAddress(
                  placeOrderFor[0]?.shipping_address?.address1,
                  placeOrderFor[0]?.shipping_address?.address2,
                  placeOrderFor[0]?.shipping_address?.city,
                  placeOrderFor[0]?.shipping_address?.state
                  ||
                  placeOrderFor[0]?.shipping_address?.province,
                  placeOrderFor[0]?.shipping_address?.zip
                ) : [
                  placeOrderFor[0]?.shipping_address?.address1,
                  placeOrderFor[0]?.shipping_address?.address2,
                  placeOrderFor[0]?.shipping_address?.city,
                  placeOrderFor[0]?.shipping_address?.state || placeOrderFor[0]?.shipping_address?.province,
                  placeOrderFor[0]?.shipping_address?.zip
                ].join(", ")
                } */}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <br />
        <FormProvider methods={method} onSubmit={handleSubmit(placeOrder)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RHFSearchableSelectField
                variant="filled"
                width="100%"
                name="package"
                label="Select Package (LxBxH) - (cm)"
                options={
                  packageList?.map((pkg) => ({
                    label: `${pkg.box_name} - (${pkg.length_cm} x ${pkg.breadth_cm} x ${pkg.height_cm})`,
                    value: pkg.id,
                  })) || []
                }
              />
            </Grid>
            <Grid item xs={12}>
              <RHFSearchableSelectField
                variant="filled"
                width="100%"
                name="pickupLocation"
                label="Pickup Location *"
                options={pickupLocations.map((pickup) => ({
                  label: [pickup.name, pickup.address_line, pickup.city, pickup.state, pickup.pincode].join(", "),
                  value: pickup.id
                }))}
              />
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'right' }}>
              <Link to="/merchant-step2" style={{ color: '#3498db', textDecoration: 'underline', cursor: 'pointer' }} state={{ addPopUp: true }}>
                Add New Pickup Location
              </Link>
            </Grid>
            <Grid item xs={12}>
              <RtoAddressSelector locations={pickupLocations} pickupLocationId={pickupLocation} />
            </Grid>
            {/* {console.log(merchant,placeOrderFor)} */}
            {blendedData ?
              <Grid item xs={12}>
                <RHFRadioGroup label="Courier Selection" name="courierType" options={[
                  { label: 'Auto', value: 'auto' },
                ]} disabled={pickupLocation?.length === 0} />
              </Grid>
              :
              <Grid item xs={12}>
                <RHFRadioGroup label="Courier Selection" name="courierType" options={[
                  { label: 'Auto', value: 'auto' },
                  { label: 'Let Me Choose', value: 'custom' },
                ]} disabled={pickupLocation?.length === 0} />
              </Grid>
            }

            {courierSelection === 'custom' && (
              <Grid item xs={8}>
                {isPriceLoading ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <CircularProgress size={20} />
                    <Typography variant="body2">Fetching courier rates...</Typography>
                  </Box>
                ) : (
                  <RHFSelectField
                    variant="filled"
                    width="100%"
                    name="courierPartner"
                    label="Courier Partner"
                    noOptionsText='No courier partner available for this pickup location'
                    options={(newCourier)?.filter(row => !row.isExternal).map((c) => {
                      const hasTat = c.providerMinTatDays !== undefined && c.providerMaxTatDays !== undefined && c.providerMaxTatDays > 0
                      return {
                        label: (
                          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1.5 }}>
                            <Typography sx={{
                              fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, color: NAVY,
                              flex: '1 1 0', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            }}>
                              {(c?.parent || c?.name)}{(c?.providerDispatchMode || c?.providerServiceTypePrimary) ? ` - ${c.providerDispatchMode || c.providerServiceTypePrimary}` : ''}
                            </Typography>
                            <Chip label={formatCurrency(c?.priceAfterTax)} size='small'
                              sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.bold, bgcolor: '#e8f5e9', color: '#2e7d32', flexShrink: 0 }}
                            />
                            <Typography sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.medium, color: NAVY, flexShrink: 0, minWidth: 90, textAlign: 'center' }}>
                              {hasTat ? `TAT: ${c.providerMinTatDays}\u2013${c.providerMaxTatDays}d` : 'TAT: N/A'}
                            </Typography>
                            <Chip label={hasTat ? `EDD: ${c.minDeliveryDate}\u2013${c.maxDeliveryDate}` : 'EDD: N/A'} size='small'
                              sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.bold, bgcolor: '#e3f2fd', color: '#1565c0', flexShrink: 0 }}
                            />
                          </Box>
                        ),
                        value: c.id,
                      }
                    })}
                  />
                )}
              </Grid>
            )}
            {/* { console.log((allCouriers))} */}

            <Grid item xs={12}>
              {placeOrderFor.length > 0 && placeOrderFor[0]?.channel === 'WOO_COMMERCE' && (
                <LoadingButton
                  // disabled={placeOrderFor.length === 1}
                  loading={isCreating}
                  variant="contained"
                  size="medium"
                  type="submit"
                >
                  Create Shipment
                </LoadingButton>
              )}
              {placeOrderFor.length > 0 && placeOrderFor[0]?.channel !== 'WOO_COMMERCE' && (
                <LoadingButton
                  disabled={placeOrderFor.length === 1 && selectedRows.length === 0}
                  loading={isCreating}
                  variant="contained"
                  size="medium"
                  type="submit"
                >
                  Create Shipment
                </LoadingButton>
              )}
            </Grid>
          </Grid>
        </FormProvider>
      </MUIModal>
    </React.Fragment>
  )
}

